import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import { objectAsParams } from "../../../helpers";
import Http from '../../../Http';
import { TextField, FormControl, Button, Select, MenuItem } from '@material-ui/core';
// import {FormGroup} from '../../form/FormOpsV2'

class Refacturar extends FormComponent {

  componentDidMount() {
    const disabled = false;
    this.initial_data = true;
    this.FormConfig(
      { defaultUrl: 'refacturacion/one', saveUrl: 'refacturacion/save', backUrl: '/Ventas/Refacturaciones' },
      new Form([
        Form.Section('Buscar Factura'),
        Form.Field('autocomplete', 'factura_folio', 'Buscar Factura', '', [Validators.required], 12, [], [], [], false, false),
        Form.Section('Datos Emisor'),
        Form.Field('text', 'emisor_rfc', 'RFC', '', [Validators.required], 4, [], [], [], false, true),
        Form.Field('text', 'emisor_razon_social', 'Razon Social', '', [Validators.required], 4, [], [], [], false, true),
        Form.Field('text', 'emisor_codigo_postal', 'Codigo Postal', '', [Validators.required], 4, [], [], [], false, true),
        Form.Field('text', 'emisor_regimen_fiscal', 'Regimen Fiscal', '', [Validators.required], 4, [], [], [], false, true),
        Form.Section('Datos Receptor'),
        Form.Field('text', 'receptor_rfc', 'RFC', '', [Validators.required], 4, [], [], [], false, disabled),
        Form.Field('text', 'receptor_razon_social', 'Razon Social', '', [Validators.required], 4, [], [], [], false, disabled),
        Form.Field('text', 'receptor_codigo_postal', 'Codigo Postal', '', [Validators.required], 4, [], [], [], false, disabled),
        Form.Field('text', 'receptor_regimen_fiscal', 'Regimen Fiscal', '', [Validators.required], 4, [], [], [], false, disabled),
        Form.Field('text', 'receptor_uso_cfdi', 'Uso CFDI', '', [Validators.required], 4, [], [], [], false, disabled),
        Form.Section('Datos Pago'),
        Form.Field('select', 'metodo_pago', 'Metodo de Pago', '', [Validators.required], 6, [], [], [], false, disabled),
        Form.Field('select', 'forma_pago', 'Forma de Pago', '', [Validators.required], 6, [], [], [], false, disabled),
      ], [], 'Refacturacion'), this.formData
    );

    this.setState({
      conceptos: [],
      conceptosCatalogo: [],
      productosCatalogo: [],
      totales: {},
      loading: false,
    })

    if (this.props.match.params.id) {
      this.LoadPreds();
    }
  }

  LoadPreds = async () => {
    let id = this.props.match.params.id;
    let Res = await Http.get(`refacturacion/one/${id}`);
    if (!Res.error) {
      const { data } = Res;
      if (data && data.timbrado) {
        let formData = Form.FieldMod(this.state.FormData, 'factura_folio', "Disabled", true);
        formData = Form.FieldMod(formData, 'emisor_rfc', "Disabled", true);
        formData = Form.FieldMod(formData, 'emisor_razon_social', "Disabled", true);
        formData = Form.FieldMod(formData, 'emisor_codigo_postal', "Disabled", true);
        formData = Form.FieldMod(formData, 'emisor_regimen_fiscal', "Disabled", true);
        formData = Form.FieldMod(formData, 'receptor_rfc', "Disabled", true);
        formData = Form.FieldMod(formData, 'receptor_razon_social', "Disabled", true);
        formData = Form.FieldMod(formData, 'receptor_codigo_postal', "Disabled", true);
        formData = Form.FieldMod(formData, 'receptor_regimen_fiscal', "Disabled", true);
        formData = Form.FieldMod(formData, 'receptor_uso_cfdi', "Disabled", true);
        formData = Form.FieldMod(formData, 'metodo_pago', "Disabled", true);
        formData = Form.FieldMod(formData, 'forma_pago', "Disabled", true);
        this.setState({ FormData: formData, disabled: true });
      }
      this.facturaFolioChange({ Value: Res.data.id_new_factura })
    }
    return Res.data;
  }

  formData = async (form) => {
    const params = {}
    let newForm = form;
    params.initial_data = this.initial_data;
    if (this.folioChange) {
      params.folio_busqueda = this.folioChange;
      this.folioChange = '';
    }

    let Res = await Http.get(`refacturacion/form?${objectAsParams(params)}`);

    if (!Res.error) {
      const { metodos_pago, formas_pago, facturas, conceptos_catalogo, productos_facturar } = Res.data;
      if (formas_pago) {
        newForm = Form.FieldOptions(newForm, 'forma_pago', formas_pago, 'forma', 'forma_nombre');
      }
      if (metodos_pago) {
        newForm = Form.FieldOptions(newForm, 'metodo_pago', metodos_pago, 'metodo', 'metodo_nombre');
      }
      if (facturas) {
        newForm = Form.FieldOptions(newForm, 'factura_folio', facturas, 'id', 'label');
      }
      if (conceptos_catalogo) {
        this.setState({
          conceptosCatalogo: conceptos_catalogo
        });
      }
      if (productos_facturar) {
        this.setState({
          productosCatalogo: productos_facturar
        });
      }
      this.initial_data = false;
    }

    newForm = Form.ValueChange(newForm, {
      factura_folio: this.facturaFolioChange,
    });
    return newForm;
  }

  facturaFolioChange = async (field) => {
    if (field.Value && field.Value !== '') {
      let Res = await Http.get(`refacturacion/factura-info/${field.Value}`);
      this.setState({
        FormData: Form.Patch(this.state.FormData, Res.data),
        conceptos: Res.data.conceptos,
        totales: {
          subtotal: Res.data.subtotal,
          iva: Res.data.iva,
          retencion: Res.data.retencion,
          total: Res.data.total,
        },
      })
    } else {
      if (field.ValueAt && field.ValueAt.length > 2) {
        this.folioChange = field.ValueAt;
        this.setState({
          FormData: await this.formData(this.state.FormData)
        });
      }
    }
  }

  onAddConcepto = () => {
    this.setState({
      conceptos: [
        ...this.state.conceptos,
        {
          id: null,
          concepto: '',
          descripcion: '',
          importe: 0.0,
          retencion: 0.0,
          iva: 0.0,
        }
      ]
    })
  }

  onDeleteConcepto = (index) => {
    this.setState({
      conceptos: this.state.conceptos.filter((c, i) => (i !== index))
    });
  }

  onConceptoChange = (index, field, value) => {
    const { conceptos } = this.state;

    conceptos[index][field] = value;
    this.setState({ conceptos });
  }

  onTotalesChange = (field, value) => {
    const { totales } = this.state;
    totales[field] = value;

    this.setState({ totales });
  }

  onSave = async (timbrar) => {
    const { FormData, conceptos, totales } = this.state;
    let values = {};
    this.setState({ loading: true });
    for (const field of FormData.Fields) {
      if (field.Type !== 'section' && field.Type !== 'space' && field.Type !== 'button') {
        values[field.Name] = field.Value;
      }
    }
    values.conceptos = conceptos;
    values.id = this.props.match.params.id;
    values = {
      ...values,
      ...totales,
      factura_id_original: values.factura_folio,
      timbrar,
    };
    try {
      const Res = await Http.post(`${this.config.saveUrl}`, values);

      if (!Res.error) {
        this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true });
        this.props.history.push(`${this.config.backUrl}`)
      } else {
        this.setState({ loading: false, sbMsg: `Error al guardar${(Res.errMsg ? `: ${Res.errMsg}` : '')}`, sbOpen: true });
      }

    } catch (error) {
      console.error(error)
    }
  }

  renderConceptos = (conceptos = []) => {
    const { conceptosCatalogo, productosCatalogo, disabled } = this.state;
    return (
      <div className='form-box' >
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} >
          <h3>Conceptos</h3> 
          { !disabled &&
            <Button color='primary' variant='contained' onClick={this.onAddConcepto} >
              Agregar Concepto
            </Button>
          }
        </div>

        {conceptos && conceptos.length > 0 &&
          conceptos.map((concepto, index) => (
            <div className='row' key={concepto.id} >
              <div className='col-sm-2' >
                <FormControl variant="outlined" className="form-field">
                  <Select
                    value={concepto["concepto"]}
                    type="text"
                    label="Concepto"
                    variant="outlined"
                    onChange={(e) => { this.onConceptoChange(index, "concepto", e.target.value) }}
                    disabled={disabled}
                  >
                    {
                      conceptosCatalogo.map(conceptoOption =>
                        <MenuItem
                          key={conceptoOption.id}
                          value={conceptoOption.id} >
                          {conceptoOption.label}
                        </MenuItem>
                      )
                    }
                  </Select>
                </FormControl>
              </div>
              <div className='col-sm-2' >
                <FormControl variant="outlined" className="form-field">
                  <Select
                    value={concepto["producto"]}
                    type="text"
                    label="Producto"
                    variant="outlined"
                    disabled={disabled}
                    onChange={(e) => { this.onConceptoChange(index, "producto", e.target.value) }}
                  >
                    {
                      productosCatalogo.map(conceptoOption =>
                        <MenuItem
                          key={conceptoOption.producto_clave}
                          value={conceptoOption.producto_clave} >
                          {conceptoOption.producto_clave} - {conceptoOption.producto_nombre}
                        </MenuItem>
                      )
                    }
                  </Select>
                </FormControl>
              </div>
              <div className='col-sm-2' >
                <FormControl variant="outlined" className="form-field">
                  <TextField
                    value={concepto["descripcion"]}
                    type="text"
                    disabled={disabled}
                    label="Descripcion"
                    variant="outlined"
                    onChange={(e) => { this.onConceptoChange(index, "descripcion", e.target.value) }}
                  />
                </FormControl>
              </div>
              <div className='col-sm-2' >
                <FormControl variant="outlined" className="form-field">
                  <TextField
                    value={concepto["importe"]}
                    type="text"
                    label="Importe"
                    disabled={disabled}
                    variant="outlined"
                    onChange={(e) => { this.onConceptoChange(index, "importe", e.target.value) }}
                  />
                </FormControl>
              </div>
              <div className='col-sm-2' >
                <FormControl variant="outlined" className="form-field">
                  <TextField
                    value={concepto["retencion"]}
                    type="text"
                    label="Retencion"
                    disabled={disabled}
                    variant="outlined"
                    onChange={(e) => { this.onConceptoChange(index, "retencion", e.target.value) }}
                  />
                </FormControl>
              </div>
              <div className='col-sm-1' >
                <FormControl variant="outlined" className="form-field">
                  <TextField
                    value={concepto["iva"]}
                    type="text"
                    label="I.V.A."
                    disabled={disabled}
                    variant="outlined"
                    onChange={(e) => { this.onConceptoChange(index, "iva", e.target.value) }}
                  />
                </FormControl>
              </div>
              <div className='col-sm-1' > 
                   
                { !disabled &&
                  <Button color='primary' variant='outlined' onClick={() => { this.onDeleteConcepto(index) }} >
                    Borrar
                  </Button>
                }
              </div>
            </div>
          ))
        }
      </div>
    )
  }

  renderTotales = (total = {}) => {
    const { disabled } = this.state;
    return (
      <div className='form-box' >
        <h3>Montos</h3>
        <div className='row'>
          <div className='col-sm-3' >
            <FormControl variant="outlined" className="form-field">
              <TextField
                value={total["subtotal"] || 0}
                type="text"
                label="Subtotal"
                variant="outlined"
                onChange={(e) => { this.onTotalesChange('subtotal', e.target.value) }}
                disabled={disabled}
              />
            </FormControl>
          </div>
          <div className='col-sm-3' >
            <FormControl variant="outlined" className="form-field">
              <TextField
                value={total["iva"] || 0}
                type="text"
                label="IVA"
                variant="outlined"
                onChange={(e) => { this.onTotalesChange('iva', e.target.value) }}
                disabled={disabled}
                />
            </FormControl>
          </div>
          <div className='col-sm-3' >
            <FormControl variant="outlined" className="form-field">
              <TextField
                value={total["retencion"] || 0}
                type="text"
                label="Retencion"
                variant="outlined"
                onChange={(e) => { this.onTotalesChange('retencion', e.target.value) }}
                disabled={disabled}
                />
            </FormControl>
          </div>
          <div className='col-sm-3' >
            <FormControl variant="outlined" className="form-field">
              <TextField
                value={total["total"] || 0}
                type="text"
                label="Total"
                variant="outlined"
                onChange={(e) => { this.onTotalesChange('total', e.target.value) }}
                disabled={disabled}
                />
            </FormControl>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { conceptos, totales, disabled, loading } = this.state;
    return (
      <div>
        <this.FormRender />
        {
          this.renderConceptos(conceptos)
        }
        {
          this.renderTotales(totales)
        }
        <div className='form-box' style={{ display: 'flex', justifyContent: 'flex-end' }}  >
          <Button 
            disabled={disabled || loading}
            color='primary' 
            variant='contained' 
            style={{ marginRight: 10 }} 
            loading={loading}
            onClick={() => { this.onSave(true) }} >Guardar y Timbrar</Button>
          <Button 
            disabled={disabled || loading}
            color='primary'
            variant='contained' 
            loading={loading}
            onClick={() => { this.onSave(false) }} >Guardar</Button>
        </div>
      </div>
    )
  }
}

export default withRouter(Refacturar);
